"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputLabel = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var OptionalMessage_1 = require("../OptionalMessage");
var Tooltip_1 = require("../Tooltip");
var InputLabel = function (props) {
    var id = props.id, label = props.label, isOptional = props.isOptional, tooltipText = props.tooltipText, attributes = __rest(props, ["id", "label", "isOptional", "tooltipText"]) // tslint:disable-line
    ;
    var TooltipTextComponent;
    attributes["htmlFor"] = id;
    var onLabelClick = function (event) {
        if (tooltipText) {
            event.preventDefault();
        }
        return;
    };
    if (tooltipText) {
        TooltipTextComponent = (React.createElement(Tooltip_1.Tooltip, { text: label, tooltipText: tooltipText, icon: true, id: id + "-helptext" }));
        attributes["onClick"] = onLabelClick;
    }
    var renderLabel = function () {
        if (isOptional) {
            return (React.createElement("span", null,
                tooltipText ? TooltipTextComponent : label,
                React.createElement(OptionalMessage_1.OptionalMessage, null)));
        }
        else {
            return (React.createElement(React.Fragment, null, tooltipText ? TooltipTextComponent : label));
        }
    };
    return (React.createElement("label", __assign({}, attributes), renderLabel()));
};
exports.InputLabel = InputLabel;
exports.InputLabel.propTypes = {
    id: PropTypes.string.isRequired,
    isOptional: PropTypes.bool,
    label: PropTypes.string.isRequired,
    tooltipText: PropTypes.string,
};
